import { useTranslation } from "react-i18next";
import {
  useCreateHomeworkIdea,
  useGetHomeworkIdea,
  getHomeworkIdea,
} from "@packages/api/madlenAPI";
import { HomeworkIdeaResponseDto } from "@packages/api/madlenAPI.schemas";
import {
  HomeworkCreateModal,
  CreateModalProps,
} from "../../../components/create-modal/modals";
import { HomeworkIdeaCard } from "../../../components/homework_ideas/HomeworkIdeaCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateHomeworkIdeaView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <HomeworkCreateModal
      title={t("homeworkIdeas.form.generateButton")}
      backPath="/content/homework-ideas"
      loadingTitle={t("homeworkIdeas.form.loading")}
      errorTitle={t("homeworkIdeas.result.error.title")}
      errorDescription={t("homeworkIdeas.result.error.loadingError")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={onSubmit!}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: HomeworkIdeaResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => {
    return (
      <HomeworkIdeaCard
        homeworkIdea={toolData}
        isImageLoading={isImageLoading}
        onCreateAgain={onCreateAgain}
      />
    );
  };

  return (
    <GenericToolCreationPage
      toolType="homework-ideas"
      useCreateTool={useCreateHomeworkIdea}
      useGetTool={useGetHomeworkIdea}
      getTool={getHomeworkIdea}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: HomeworkIdeaResponseDto) => data?.title}
    />
  );
};

export default CreateHomeworkIdeaView;
